import { Stack } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxToggleButton from "components/UI/AcxToggleButton";
import { observer } from "mobx-react";
import TableCardStore from "../TableCardStore";
import { RenderModeType } from "../../../SignalsModels";
import ExtractionLlmClassifierControl from "./ExtractionLlmClassifierControl";

const TableControls = observer(({ store }: { store: TableCardStore }) => {
    const showPercentToggle = store.config.capabilities.renderModes.length > 1;

    const selectionType = store.selectionType;
    const showLlmClassifierExtractedMetadataControl =
        selectionType === "LLM Classifier Extracted Metadata";

    return (
        <Stack
            justifyContent="space-between"
            direction="row"
            columnGap={2}
            width="100%"
        >
            <Stack
                direction="row"
                alignItems="center"
                columnGap={1}
                maxWidth="50%"
                width="100%"
            >
                {showLlmClassifierExtractedMetadataControl && (
                    <ExtractionLlmClassifierControl store={store} />
                )}
            </Stack>
            <Stack direction="row" alignItems="center" columnGap={1}>
                {showPercentToggle && (
                    <AcxToggleButton
                        id={`${store.id}-table-percent-count-toggle`}
                        items={["%", "#"]}
                        shrink
                        onChange={() => {
                            store.toggleRenderMode();
                        }}
                        exclusive
                        defaultValue={
                            store.currentRenderMode === RenderModeType.Count
                                ? "#"
                                : "%"
                        }
                        style={{
                            height: "36px",
                            marginLeft: theme.spacing(1),
                        }}
                    />
                )}
            </Stack>
        </Stack>
    );
});

export default TableControls;
